module.exports = __webpack_public_path__ + "assets/lit-html.a9ea682d.svg";